import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { get, put } from '@app/api/typed';
import type { ApiError } from '@app/api/ApiError';
import type {
  EnvironmentApprovalRules,
  EnvironmentApprovalRulesInput,
} from './ApprovalWorkflowModel';

export const approvalWorkflowKeys = {
  environment: (id: string) => ['tenant', 'environment-approval-rules', id] as const,
};
const path = (id: string) =>
  `/api/v1/tenant/environments/${encodeURIComponent(id)}/approval-rules` as '/api/v1/tenant/environments/{id}/approval-rules';

export function useEnvironmentApprovalRules(id: string, enabled = true) {
  return useQuery<EnvironmentApprovalRules, ApiError>({
    queryKey: approvalWorkflowKeys.environment(id),
    queryFn: () => get(path(id)),
    enabled,
  });
}

export function useUpdateEnvironmentApprovalRules(id: string) {
  const client = useQueryClient();
  return useMutation<EnvironmentApprovalRules, ApiError, EnvironmentApprovalRulesInput>({
    mutationFn: (body) => put(path(id), { body }),
    onSuccess: (saved) => client.setQueryData(approvalWorkflowKeys.environment(id), saved),
  });
}
